import React, { useEffect, useState } from "react"
import { db } from "./firebase"
import {
  collection,
  query,
  where,
  orderBy,
  limit,
  onSnapshot
} from "firebase/firestore"

// keep your existing icons exactly as you defined them
const SOURCES = [
  { key: "temperature",  coll: "iot-bushfire-alerts", field: "temperature",   label: "Heat Sensor",  icon: <img src="/heat.jpg"  alt="Heat"  style={{ width: 48, height: 48 }} />, unit: "°C" },
  { key: "smoke_ppm",     coll: "iot-bushfire-alerts", field: "smoke_ppm",    label: "Smoke Sensor", icon: <img src="/smoke.jpg" alt="Smoke" style={{ width: 48, height: 48 }} />, unit: "ppm" },
  { key: "sound_level",   coll: "iot-poaching-alerts", field: "sound_level",  label: "Sound Sensor", icon: <img src="/sound.jpg" alt="Sound" style={{ width: 48, height: 48 }} />, unit: "dB" },
]

export default function SensorPanel({ zone }) {
  const [latest, setLatest] = useState({})

  useEffect(() => {
    // subscribe once per source
    const unsubs = SOURCES.map(({ key, coll, field }) => {
      const q = query(
        collection(db, coll),
        where("zone", "==", `Zone-${zone}`),
        where(field, "!=", null),
        orderBy("timestamp", "desc"),
        limit(1)
      )
      return onSnapshot(q, snap => {
        if (!snap.empty) {
          setLatest(l => ({ ...l, [key]: snap.docs[0].data() }))
        }
      })
    })
    return () => unsubs.forEach(u => u())
  }, [zone])

  return (
    <div className="bg-white p-5 rounded-lg shadow-md w-full">
      <h3 className="text-xl font-semibold mb-4">Zone {zone} Sensors</h3>
      <div className="space-y-2 text-sm">
        {SOURCES.map(({ key, label, icon, unit }) => {
          const r = latest[key]
          return (
            <div key={key} className="flex justify-between bg-gray-50 p-3 rounded-md border">
              <div>
                <p className="font-semibold">{label}</p>
                {r ? (
                  <>
                    <p><strong>Value:</strong> {r[key]}{unit}</p>
                    <p><strong>Time:</strong> {new Date(r.timestamp).toLocaleTimeString()}</p>
                    {r.severity && <p className="text-red-600"><strong>Alert:</strong> {r.severity}</p>}
                  </>
                ) : (
                  <p className="text-gray-500">No data yet</p>
                )}
              </div>
              <div className="text-2xl">{icon}</div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
